import React from "react";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";

export default function ProButton({ children, isSaving, isDisabled = false, ...props }) {
  return (
    <Button data-test-id="action-button" disabled={isSaving || isDisabled} variant="contained" color="primary" {...props}>
      {children}
    </Button>
  );
}

ProButton.propTypes = {
  children: PropTypes.node.isRequired,
  isSaving: PropTypes.bool,
  isDisabled: PropTypes.bool
};
